import Vec2 from 'vec2';

export const calculateNormalVector = (dirVec: Vec2): Vec2 => {
  const normalVecX =
    dirVec.x * Math.cos(Math.PI / 2) - dirVec.y * Math.sin(Math.PI / 2);
  const normalVecY =
    dirVec.x * Math.sin(Math.PI / 2) + dirVec.y * Math.cos(Math.PI / 2);
  const normalVecLength = Math.sqrt(
    normalVecX * normalVecX + normalVecY * normalVecY
  );

  return new Vec2(
    normalVecLength > 0 ? normalVecX / normalVecLength : 0,
    normalVecLength > 0 ? normalVecY / normalVecLength : 0
  );
};
